import {
    API_SUCCESS,
    API_FAIL,
    GET_CHARTS_DATA,
    DASHBOARD_USER_DATA,
    DASHBOARD_USER_DATA_SUCCESS
} from "./actionTypes";

const INIT_STATE = {
    chartsData: [],
    user: null,
    loading: false,
    error: ""
};

const Dashboard = (state = INIT_STATE, action) => {
    switch (action.type) {
        case API_SUCCESS:
            switch (action.payload.actionType) {
                case GET_CHARTS_DATA:
                    return {
                        ...state,
                        chartsData: action.payload.data
                    };
                default:
                    return state;
            }
        case API_FAIL:
            switch (action.payload.actionType) {
                case GET_CHARTS_DATA:
                    return {
                        ...state,
                        chartsDataError: action.payload.error
                    };


                default:
                    return state;
            }
        case DASHBOARD_USER_DATA:
           return{
                ...state,
                loading: true,
                error: "",
            }
        case DASHBOARD_USER_DATA_SUCCESS:
            return{
                ...state,
                loading: false,
                error: "",
                user: action.payload,
            }
        default:
            return state;
    }
}


export default Dashboard;